var _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconService4 = function SvgIconService4(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "#1D2E69",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1D2E69",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 31.2v20.49h8.929v3.542H54V35.747h-5.357V25H35.25C31.804 25 29 27.781 29 31.2zm23.214 22.261h-12.5V37.518h12.5v15.943zm-5.357-17.714H37.93v14.171h-7.143V32.086h5.357V26.77h10.714v8.976zm-12.5-8.886v3.453h-3.481a4.46 4.46 0 0 1 3.481-3.453z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 46.375h1.786v1.772H41.5zM45.071 46.375h1.786v1.772h-1.786zM48.643 46.375h1.786v1.772h-1.786zM41.5 49.918h1.786v1.772H41.5zM45.071 49.918h1.786v1.772h-1.786zM48.643 49.918h1.786v1.772h-1.786zM50.429 39.29H41.5v5.314h8.929V39.29zm-1.786 3.542h-5.357v-1.771h5.357v1.771z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconService4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-service-4.f9200f24.svg";
export { ForwardRef as ReactComponent };